export default "__VITE_PUBLIC_ASSET__05501853__"